import { render } from "./BIBO.vue?vue&type=template&id=44f2c7db"
import script from "./BIBO.vue?vue&type=script&lang=ts"
export * from "./BIBO.vue?vue&type=script&lang=ts"
script.render = render

export default script